import React, { useEffect, useState } from "react";
import MdTrash from "react-ionicons/lib/MdTrash";
import Error from "../Error";
import { useFieldArray } from "react-hook-form";
import OptionForm from "./OptionForm";
import ModalDelete from "../../common/ModalDelete";

import MdArrowUp from "react-ionicons/lib/MdArrowUp";
import MdArrowDown from "react-ionicons/lib/MdArrowDown";

const ExtraForm = ({
  id,
  title,
  min,
  max,
  required,
  register,
  errors,
  extraIndex,
  removeExtra,
  control,
  options,
  moveUp,
  canMoveUp,
  moveDown,
  canMoveDown,
}) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [scrollToId, setScrollToId] = useState("");

  var subtitle;

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: `extras[${extraIndex}].options`,
      // keyName: "id", default to "id", you can change the key name
    }
  );

  const removeExtraM = () => {
    removeExtra(extraIndex);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const optionMoveUp = (index) => {
    swap(index - 1, index);
  };

  const optionMoveDown = (index) => {
    swap(index, index + 1);
  };

  useEffect(() => {
    if (scrollToId !== "") {
      const element = document.getElementById(scrollToId);
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [fields]);

  const moveUpOption = (index) => {
    swap(index - 1, index);
    setScrollToId(fields[index - 1].id);
  };

  const moveDownOption = (index) => {
    swap(index, index + 1);
    setScrollToId(fields[index + 1].id);
  };

  return (
    <form
      className="product-form flex border-2 border-gray-200 p-4 rounded-md mb-4 relative"
      id={id}
    >
      <ModalDelete
        message="¿Estás seguro que quieres borrar los datos del extra?
                    Todos los datos serán perdidos permanentemente. Esta acción
                    no se puede revertir."
        closeModal={closeModal}
        modalIsOpen={modalIsOpen}
        remove={removeExtraM}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        subtitle={subtitle}
        title="Borrar extra"
      ></ModalDelete>
      <div className="w-full">
        <div className="controls flex mb-2">
          {canMoveUp && (
            <button
              type="button"
              onClick={() => moveUp(extraIndex)}
              className="text-xs inline-flex items-center mr-2 bg-white rounded border py-1 px-3"
            >
              <MdArrowUp fontSize=".875rem" className="mr-1"></MdArrowUp> Mover
              un nivel arriba
            </button>
          )}
          {canMoveDown && (
            <button
              type="button"
              onClick={() => moveDown(extraIndex)}
              className="text-xs inline-flex items-center bg-white rounded border py-1 px-3"
            >
              <MdArrowDown fontSize=".875rem" className="mr-1"></MdArrowDown>{" "}
              Mover un nivel abajo
            </button>
          )}
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`extras[${extraIndex}].title`}
          >
            Nombre
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name={`extras[${extraIndex}].title`}
            ref={register()}
            defaultValue={title}
            placeholder="Nombre del extra"
          />
          <Error error={errors ? errors.title : null} left></Error>
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`extras[${extraIndex}].max`}
          >
            Opciones máximas
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="number"
            name={`extras[${extraIndex}].max`}
            ref={register()}
            defaultValue={max}
            placeholder="Máxima cantidad de opciones"
          />
          <Error error={errors ? errors.max : null} left></Error>
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`extras[${extraIndex}].min`}
          >
            Opciones mínimas
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="number"
            name={`extras[${extraIndex}].min`}
            ref={register()}
            defaultValue={min}
            placeholder="Mínima cantidad de opciones"
          />
          <Error error={errors ? errors.min : null} left></Error>
        </div>
        <div className="mb-4 w-full input flex items-center">
          <input
            type="checkbox"
            name={`extras[${extraIndex}].required`}
            ref={register()}
            defaultChecked={required}
          />
          <label
            className="block text-gray-700 text-sm font-bold ml-2"
            htmlFor={`extras[${extraIndex}].required`}
          >
            Requerido
          </label>
          <Error error={errors ? errors.required : null} left></Error>
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="price"
          >
            Opciones
          </label>
          {fields && fields.length > 0
            ? fields.map((option, index) => {
                return (
                  <OptionForm
                    key={option.id}
                    removeOption={remove}
                    {...option}
                    register={register}
                    errors={
                      errors && errors.options ? errors.options[index] : {}
                    }
                    optionIndex={index}
                    extraIndex={extraIndex}
                    moveUp={moveUpOption}
                    moveDown={moveDownOption}
                    canMoveUp={index > 0}
                    canMoveDown={index < fields.length - 1}
                  ></OptionForm>
                );
              })
            : null}
          <Error
            error={errors && errors.options ? errors.options : null}
            left
          ></Error>
          <button
            type="button"
            onClick={() =>
              append({
                title: "",
                price: 0,
              })
            }
            className="bg-gray-300 rounded-md text-gray-700 py-2 px-4 text-sm font-bold border-2 border-gray-500"
          >
            Agregar opción
          </button>
        </div>
        <MdTrash onClick={openModal} className="trash"></MdTrash>
      </div>
    </form>
  );
};

export default ExtraForm;
